import React, { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { fetchApiData } from "../../../store/slicers/apiSlicer.js";
import "../../styles/events.css";
import AppLayout from "../../layouts/AppLayout.jsx";

const Content = () => {
  const dispatch = useDispatch();
  const [events, setEvents] = useState([]);
  const [filterType, setFilterType] = useState('all'); // 'all', 'upcoming', 'past'
  const [filterCategory, setFilterCategory] = useState('all');
  const [categories, setCategories] = useState([]);

  const { data, isLoading } = useSelector((state) => ({
    data: state.apiData?.data?.allEvents,
    isLoading: state.apiData?.loading?.allEvents
  }));

  useEffect(() => {
    dispatch(fetchApiData({ url: 'events', itemKey: 'allEvents' }));
  }, [dispatch]);

  useEffect(() => {
    if (data?.data?.data) {
      setEvents(data.data.data);
      
      // Extraire les catégories uniques
      const uniqueCategories = [...new Set(
        data?.data?.data
          .map(event => event.category)
          .filter(cat => cat)
      )];
      setCategories(uniqueCategories);
    }
  }, [data]);

  const formatDate = (date) => {
    return new Date(date).toLocaleDateString('fr-FR', {
      weekday: 'long',
      day: '2-digit',
      month: 'long',
      year: 'numeric'
    });
  };

  const formatTime = (time) => {
    return time ? time.slice(0, 5) : '';
  };

  const isUpcoming = (date) => {
    return new Date(date) >= new Date();
  };

  const filteredEvents = events.filter(event => {
    const typeMatch = filterType === 'all' 
      || (filterType === 'upcoming' && isUpcoming(event.date))
      || (filterType === 'past' && !isUpcoming(event.date));
    
    const categoryMatch = filterCategory === 'all' || event.category === filterCategory;
    
    return typeMatch && categoryMatch;
  });

  if (isLoading) {
    return <p className="loading">Chargement des événements...</p>;
  }

  return (
    <div className="events-grid-container">
      <h2 className="events-grid-header">
        <i className="pi pi-calendar"></i> Tous les Événements
      </h2>

      {/* Filtres */}
      <div className="events-filters">
        <div className="filter-group">
          <label>Type :</label>
          <select 
            value={filterType} 
            onChange={(e) => setFilterType(e.target.value)}
            className="filter-select"
          >
            <option value="all">Tous</option>
            <option value="upcoming">À venir</option>
            <option value="past">Passés</option>
          </select>
        </div>

        <div className="filter-group">
          <label>Catégorie :</label>
          <select 
            value={filterCategory} 
            onChange={(e) => setFilterCategory(e.target.value)}
            className="filter-select"
          >
            <option value="all">Toutes</option>
            {categories.map((cat, index) => (
              <option key={index} value={cat}>{cat}</option>
            ))}
          </select>
        </div>
      </div>

      {/* Grille d'événements */}
      {filteredEvents.length > 0 ? (
        <div className="events-grid">
          {filteredEvents.map((event) => (
            <div 
              key={event.id} 
              className={`event-card ${!isUpcoming(event.date) ? 'past-event' : ''}`}
            >
              <div className="event-info">
                <div className="event-header-section">
                  <h3 className="event-title">{event.title}</h3>
                  {event.category && (
                    <span className={`event-category-badge ${!isUpcoming(event.date) ? 'past' : ''}`}>
                      {event.category}
                    </span>
                  )}
                </div>

                <div className="event-meta">
                  <div className="event-date-time">
                    <span className="event-date">
                      <i className="pi pi-calendar"></i>
                      {formatDate(event.date)}
                    </span>
                    {event.time && (
                      <span className="event-time">
                        <i className="pi pi-clock"></i>
                        {formatTime(event.time)}
                      </span>
                    )}
                  </div>

                  {event.location && (
                    <span className="event-location">
                      <i className="pi pi-map-marker"></i>
                      {event.location}
                    </span>
                  )}
                </div>

                {event.description && (
                  <p className="event-description">{event.description}</p>
                )}

                {!isUpcoming(event.date) && (
                  <span className="past-badge">
                    <i className="pi pi-check-circle"></i> Événement terminé
                  </span>
                )}
              </div>
            </div>
          ))}
        </div>
      ) : (
        <p className="no-events">Aucun événement trouvé</p>
      )}
    </div>
  );
};

const EventDetail = () => {
  return (
    <>
        <AppLayout>
            <Content />
        </AppLayout>
    </>
  );
}

export default EventDetail;